import { useContext } from 'react';
import { ReportsContext } from '../../providers/ReportsProvider/ReportsProvider';

export default function useReports() {
	return useContext(ReportsContext);
}
